import AudioLibrary from './AudioLibrary';
import { IAudioLibraryProps, SampleAudioRecord } from './types';

export default AudioLibrary;
export { IAudioLibraryProps as AudioLibraryProps, SampleAudioRecord };
